"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayEventEntity = void 0;
class DisplayEventEntity {
    _id;
    id;
    timestamp;
    metadata;
    category;
    type;
    severity;
    payload;
    source;
    screenshot;
}
exports.DisplayEventEntity = DisplayEventEntity;
